import { createFileRoute } from "@tanstack/react-router";
import { parseHubFilters } from "@/components/outreach/hub-filters";
import { OutreachHub } from "@/components/outreach/OutreachHub";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/_app/_/outreach/")({
	validateSearch: parseHubFilters,
	component: OutreachHubPage,
});

function OutreachHubPage() {
	const session = useSession();
	const campaignId = session.campaign?.id;
	const filters = Route.useSearch();
	const navigate = Route.useNavigate();
	if (!campaignId) {
		return (
			<div className="mx-auto max-w-5xl p-6">
				<p className="text-muted-foreground">
					No campaign found. Please complete onboarding first.
				</p>
			</div>
		);
	}
	return (
		<OutreachHub
			campaignId={campaignId}
			accountName={session.campaign?.name ?? undefined}
			filters={filters}
			onFiltersChange={(patch) =>
				navigate({
					search: (prev) => ({ ...prev, ...patch }),
					replace: true,
				})
			}
		/>
	);
}
